import { get } from './base'

export const getStats = ({ params }: any) => {
  return get('stats', { params })
}
